// extracted by mini-css-extract-plugin
module.exports = {"base":"CBButton_base__2ye08","border":"CBButton_border__2F_qq","borderRight":"CBButton_borderRight__10lMB","borderLeft":"CBButton_borderLeft__gERas"};